






import Vue from 'vue';

export default Vue.extend({
  name: 'ProfileIcon',
  props: {
    name: String,
    size: Number,
    color: String,
    backgroundColor: String,
  },
  computed: {
    styles(): Record<string, string | undefined> {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderRadius: `${this.size/2}px`,
        lineHeight: `${this.size}px`,
        color: this.color ? this.color : undefined,
        backgroundColor: this.backgroundColor ? this.backgroundColor : undefined,
      };
    },
    initial(): string {
      const nameArray = this.name.split(' ');
      return nameArray.map((n: string) => n[0]).join('').toUpperCase().substring(0, 3);
    },
  },
});
